<template>
  <div class="account_manage">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="headertitle">子账号管理</span>
        <el-button style="float: right;backgroundColor:#be3c6e;border-color:#be3c6e" type="primary"
          @click="dialogVisible = true">新增子账号</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="用户名">
          <template slot-scope="scope">
            <i class="el-icon-s-custom"></i>
            <span style="margin-left: 10px">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="邮箱">
          <template slot-scope="scope">
            <i class="el-icon-message"></i>
            <span style="margin-left: 10px">{{ scope.row.email }}</span>
          </template>
        </el-table-column>
        <el-table-column label="最近登录记录">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.date }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button size="mini" plain type="primary" @click="handleEdit(scope.$index, scope.row)">移交权限</el-button>
            <el-button size="mini" type="info" @click="handleDelete(scope.$index, scope.row)">登录记录</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增 -->
    <el-dialog title="新增子账号" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form label-position="right" label-width="80px" :model="formAccount" :rules="rules">
        <el-form-item label="邮箱" prop="email">
          <el-input class="input-specil" v-model="formAccount.email"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input class="input-specil" v-model="formAccount.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [{
        date: '2023-05-02',
        name: '张三',
        email: '123@hsdhfjkd.com'
      }, {
        date: '2023-05-04',
        name: '李四',
        email: '123@hsdhfjkd.com'
      }, {
        date: '2023-05-01',
        name: '王五',
        email: '123@hsdhfjkd.com'
      }, {
        date: '2023-05-03',
        name: '王小虎',
        email: '123@hsdhfjkd.com'
      }],
      dialogVisible: false,
      formAccount: {
        email: '',
        password: '',
      },
      rules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
      }
    }
  },
  mounted() {

  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    }
  }

}
</script>
<style lang="less" scoped>
.headertitle {
  display: inline-block;
  font-size: 20px !important;
}

.input-specil {
  width: calc(100% - 100px) !important;
}
</style>
